import { useEffect, useState } from "react";
import { Col, Dropdown, Menu, message, Row, TableColumnsType } from "antd";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import Table from "@components/Table";
import Button from "@components/Button";
import {
  ErrorServices,
  useDeleteSubJobFunctionMutation,
  useFetchJobFunctionByIdQuery,
} from "@services";
import AddJobSubFunction from "./AddJobSubFunction";
import EditJobSubFunction from "./EditJobSubFunction";
import { ReactComponent as MenuIcon } from "@assets/images/vertical-dots.svg";
import { useTypedSelector } from "@/hooks";

type SubJobFunctionType = {
  id: number;
  name: string;
};

const SubJobFunction = () => {
  const [isAddJSFVisible, setIsAddJSFVisible] = useState(false);
  const [isEditJSFVisible, setIsEditJSFVisible] = useState(false);
  const [jsfItem, setJsfItem] = useState({});
  const [deleteSubJobFunction] = useDeleteSubJobFunctionMutation();
  const { job_id } = useParams<{ job_id: string }>();
  const history = useHistory();
  const { user, permissions: per } = useTypedSelector(state => state.auth);
  console.log("per : ", per);

  const { data: jobFunctionData, isLoading: isLoadingJobFunctions } =
    useFetchJobFunctionByIdQuery({ job_id });
  const { data: jobFunction } = jobFunctionData || {};
  const handleActionDropdown = ({
    item,
    key,
    domEvent,
  }: {
    key: string;
    domEvent:
      | React.MouseEvent<HTMLElement, MouseEvent>
      | React.KeyboardEvent<HTMLElement>;
    item: SubJobFunctionType;
  }) => {
    domEvent.stopPropagation();
    if (key === "2") {
      removeSubJobFunction(item?.id.toString());
    } else {
      onEditJSf(item);
    }
  };

  const columns: TableColumnsType<SubJobFunctionType> = [
    {
      title: "Job Sub Function",
      key: "name",
      dataIndex: "name",
      width: `calc(100% - 260px)`,
    },
    // {
    //   title: "Actions",
    //   key: "action",
    //   width: 160,
    //   align: "center",
    //   render: (item: SubJobFunctionType) => {
    //     const menu = (
    //       <Menu
    //         onClick={({ key, domEvent }) =>
    //           handleActionDropdown({ item, key, domEvent })
    //         }
    //         tabIndex={1}
    //       >
    //         {(per?.includes("UPDATE_JOB_SUB_FUNCTION") || per?.includes("all")) && (
    //           <Menu.Item key="1">Edit</Menu.Item>
    //         )}

    //         {(per?.includes("DELETE_JOB_SUB_FUNCTION") || per?.includes("all")) && (
    //           <Menu.Item key="2" danger>
    //             Delete
    //           </Menu.Item>
    //         )}
    //       </Menu>
    //     );
    //     return (
    //       <div className="table__action__menu">
    //         <Dropdown overlay={menu} trigger={["click"]}>
    //           <MenuIcon
    //             onClick={e => {
    //               e.stopPropagation();
    //             }}
    //           />
    //         </Dropdown>
    //       </div>
    //     );
    //   },
    // },

    // ...(//   !checkPermission([
    // // permissions.UPDATE_JOB_SUB_FUNCTION,
    // // permissions.DELETE_JOB_SUB_FUNCTION,])

    // (!per?.includes("UPDATE_JOB_SUB_FUNCTION") ||
    // !per?.includes("DELETE_JOB_SUB_FUNCTION") ||
    // !per?.includes("all")
    //   ? []
    //   : [
    //       {
    //         title: "Actions",
    //         key: "action",
    //         fixed: "right",
    //         width: "10%",
    //         render: (item: SubJobFunctionType) => {
    //           const menu = (
    //             <Menu
    //               onClick={({ key, domEvent }) =>
    //                 handleActionDropdown({ item, key, domEvent })
    //               }
    //               tabIndex={1}
    //             >
    //               {
    //                 // checkPermission(permissions.UPDATE_JOB_SUB_FUNCTION)
    //                 (per?.includes("UPDATE_JOB_SUB_FUNCTION") ||
    //                   per?.includes("all")) && (
    //                   <Menu.Item key="1">Edit</Menu.Item>
    //                 )
    //               }
    //               {
    //                 // checkPermission(permissions.DELETE_JOB_SUB_FUNCTION)
    //                 (per?.includes("DELETE_JOB_SUB_FUNCTION") ||
    //                   per?.includes("all")) && (
    //                   <Menu.Item key="2" danger>
    //                     Delete
    //                   </Menu.Item>
    //                 )
    //               }
    //             </Menu>
    //           );
    //           return (
    //             <div className="table__action__menu">
    //               <Dropdown overlay={menu} trigger={["click"]}>
    //                 <MenuIcon
    //                   onClick={e => {
    //                     e.stopPropagation();
    //                   }}
    //                 />
    //               </Dropdown>
    //             </div>
    //           );
    //         },
    //       },
    //     ]) as any),

    ...((per?.includes("UPDATE_JOB_SUB_FUNCTION") ||
    per?.includes("DELETE_JOB_SUB_FUNCTION") ||
    per?.includes("all")
      ? [
          {
            title: "Actions",
            key: "action",
            fixed: "right",
            width: "10%",
            render: (item: SubJobFunctionType) => {
              const menu = (
                <Menu
                  onClick={(info: any) =>
                    handleActionDropdown({
                      item,
                      key: info.key,
                      domEvent: info.domEvent,
                    })
                  }
                  tabIndex={1}
                >
                  {(per?.includes("UPDATE_JOB_SUB_FUNCTION") ||
                    per?.includes("all")) && (
                    <Menu.Item key="1">Edit</Menu.Item>
                  )}

                  {(per?.includes("DELETE_JOB_SUB_FUNCTION") ||
                    per?.includes("all")) && (
                    <Menu.Item key="2" danger>
                      Delete
                    </Menu.Item>
                  )}
                </Menu>
              );
              return (
                <div className="table__action__menu">
                  <Dropdown overlay={menu} trigger={["click"]}>
                    <MenuIcon
                      onClick={e => {
                        e.stopPropagation(); // row click prevent
                      }}
                    />
                  </Dropdown>
                </div>
              );
            },
          },
        ]
      : []) as any),
  ];

  const onEditJSf = async (item: SubJobFunctionType) => {
    try {
      setJsfItem(item);
      setIsEditJSFVisible(true);
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const removeSubJobFunction = async (id: string) => {
    try {
      await deleteSubJobFunction({ id }).unwrap();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  return (
    <>
      <AddJobSubFunction
        setIsVisible={setIsAddJSFVisible}
        isVisible={isAddJSFVisible}
        job_function_id={job_id}
      />
      <EditJobSubFunction
        setIsVisible={setIsEditJSFVisible}
        isVisible={isEditJSFVisible}
        jsfItem={jsfItem}
        job_function_id={job_id}
      />
      <div className="appTitle text-base font-[500] mx-5">
        <span
          className="cursor-pointer"
          onClick={() => history.push("/job-functions")}
        >
          {" "}
          Job Functions{" "}
        </span>
        {" > "}
        Sub Functions
      </div>
      <div className="jobCreationBar  sticky top-0 z-10 bg-white px-14 py-6 rounded-lg flex justify-between items-center my-7">
        <div className="title text-themeBlue font-[500] text-3xl">
          Job Sub Functions
        </div>
        {(per?.includes("CREATE_JOB_SUB_FUNCTION") || per?.includes("all")) && (
          <Button variant="add" onClick={() => setIsAddJSFVisible(true)}>
            Add Job-Sub Function
          </Button>
        )}
      </div>

      <Row>
        <Table
          data={jobFunction?.job_sub_functions}
          columns={columns}
          isLoading={isLoadingJobFunctions}
        />
      </Row>
    </>
  );
};

export default SubJobFunction;
